import SettingsRepository from 'alto-settings/lib/models'

import config from './config'

# no auth for now - all settings are readable without authentication
export default settings = { repository: SettingsRepository.for(config.backendUrl, null) }
